<template>
  <div v-if="showSplash" class="splash-container">
    <div class="overlay" />

    <div class="main">
      <img
        src="../assets/images/splash/TMQ.webp"
        alt="tmq"
        width="160"
        height="160"
      />

      <img
        src="../assets/images/splash/top_menu_market.webp"
        alt="slogan"
        width="280"
        height="44"
        class="tmImage"
      />

      <div class="qualityContainer">
        <img
          src="../assets/images/splash/quality_at_the_top.webp"
          alt="slogan"
          width="240"
          height="21.6"
          class="tmImage"
        />
      </div>

      <loader />
    </div>
  </div>
</template>

<script>
import Loader from "../components/Loader.vue";
import Cookies from "js-cookie";

const SPLASH_SCREEN_COOKIE = "splash_screen";

export default {
  components: { Loader },
  name: "PreLoader",
  data() {
    return {
      showSplash: false,
    };
  },
  methods: {
    checkSplashCoockie() {
      const isSplashActive = Cookies.get(SPLASH_SCREEN_COOKIE);
      const inAnHour = new Date(Date.now() + 60 * 60 * 1000);

      if (!isSplashActive) {
        Cookies.set(SPLASH_SCREEN_COOKIE, "true", { expires: inAnHour });
        this.showSplash = true;

        const timer = setTimeout(() => {
          this.showSplash = false;
        }, 4000);

        return () => clearTimeout(timer);
      } else {
        Cookies.set(SPLASH_SCREEN_COOKIE, "true", { expires: inAnHour });
      }
    },
  },
  mounted() {
    this.checkSplashCoockie();
  },
};
</script>

<style lang="scss">
.splash-container {
  position: fixed;
  inset: 0;
  z-index: 1000000;

  .overlay {
    position: fixed;
    inset: 0;
    width: 101vw;
    height: 101vh;
    background-color: #dce0eb;
    z-index: -1;
  }

  .main {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    position: fixed;
    inset: 0;
    z-index: 10000;
    gap: 20px;

    @media screen and (max-width: 540px) {
      transform: scale(0.7);
    }
  }

  .tmImage {
    background-color: #dce0eb;
    padding-inline: 10px;
    z-index: 10;
  }

  .qualityContainer {
    position: relative;
    transform: translateY(-200%);
    animation: moveDown 0.4s ease-in-out 0.5s forwards;

    @keyframes moveDown {
      0% {
        transform: translateY(-50px);
        opacity: 0;
      }
      100% {
        transform: translateY(0);
        opacity: 1;
      }
    }
  }
}
</style>
